import { encodeEntityFolderLabelQuery, EntityFolderLabelQuery } from '@/services/api/resources/entityFolderLabel/query';
import { flow, pipe } from 'fp-ts/function';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  decode,
  fetchApi,
  setQuery,
} from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';
import { listCodec } from '@/services/api/resources/entityFolderLabel/codec';
import { filterCodec } from '@/services/api/resources/filter';

const baseUrl = '/v2/entity-folder-labels';
const filterUrl = '/v2/filters/entity-folder-labels';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (query: EntityFolderLabelQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeEntityFolderLabelQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const remove = flow(
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const filter = () => pipe(
  filterUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(filterCodec)),
);
